import { useState } from "react";
import { Trash } from "@phosphor-icons/react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel } from "@/components/ui/alert-dialog";
import { API, errorText } from "../shared";

export const ImportHistory = ({ history, onOpen, onRemoved }) => {
  const [pending, setPending] = useState(null), [busy, setBusy] = useState(false);
  const [error, setError] = useState(""), [success, setSuccess] = useState("");
  const remove = async () => {
    if (!pending || busy) return;
    setBusy(true); setError("");
    try {
      await axios.delete(`${API}/import/${pending.id}`, { data: { bevestigd: true }, timeout: 20000 });
      onRemoved(pending.id); setPending(null);
      setSuccess("Import uit de geschiedenis verwijderd. Bestellingen en productfoto’s zijn behouden.");
    } catch (e) { setError(errorText(e)); }
    finally { setBusy(false); }
  };
  return <section className="ctn-import-history" data-testid="ctn-import-history">
    <h2 data-testid="ctn-import-history-title">Recente imports</h2>
    {success && <p role="status" className="ctn-import-history-success" data-testid="ctn-import-history-deleted">{success}</p>}
    {history.length ? history.map((job) => {
      const running = ["voorbereiden", "bezig"].includes(job.status);
      return <div className="ctn-import-history-row" key={job.id} data-testid={`ctn-import-history-row-${job.id}`}>
        <button className="ctn-import-history-open" type="button" onClick={() => onOpen(job.id)} data-testid={`ctn-import-history-${job.id}`}>
          <strong data-testid={`ctn-import-history-name-${job.id}`}>{job.naam}</strong>
          <span data-testid={`ctn-import-history-status-${job.id}`}>{job.status} · {job.totaal} regels · {new Date(job.aangemaakt_op).toLocaleDateString("nl-BE")}</span>
        </button>
        <Button variant="outline" className="ctn-import-history-delete" disabled={running || busy}
          title={running ? "Deze import wordt nog verwerkt" : "Uit geschiedenis verwijderen"}
          aria-label={`${job.naam} uit geschiedenis verwijderen`}
          onClick={() => { setPending(job); setError(""); setSuccess(""); }} data-testid={`ctn-import-history-delete-${job.id}`}>
          <Trash size={18} aria-hidden="true" /><span className="hidden sm:inline">Verwijderen</span>
        </Button>
      </div>;
    }) : <p data-testid="ctn-import-history-empty">Nog geen imports voor deze gebruiker en firma.</p>}
    <AlertDialog open={Boolean(pending)} onOpenChange={(open) => { if (!open && !busy) { setPending(null); setError(""); } }}>
      <AlertDialogContent className="ctn-import-history-dialog" data-testid="ctn-import-history-delete-dialog" aria-busy={busy}>
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="ctn-import-history-delete-title">Import uit geschiedenis verwijderen?</AlertDialogTitle>
          <AlertDialogDescription data-testid="ctn-import-history-delete-description">
            <strong className="ctn-import-history-filename" data-testid="ctn-import-history-delete-name">{pending?.naam}</strong>
            Deze vergelijking verdwijnt uit Recente imports. Geïmporteerde bestellingen en productfoto’s blijven behouden.
          </AlertDialogDescription>
        </AlertDialogHeader>
        {error && <p role="alert" className="text-sm text-red-700" data-testid="ctn-import-history-delete-error">{error}</p>}
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="ctn-import-history-delete-cancel">Annuleren</AlertDialogCancel>
          <Button variant="destructive" disabled={busy} onClick={remove} data-testid="ctn-import-history-delete-confirm">{busy ? "Verwijderen…" : "Bevestigen"}</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </section>;
};